import moment, { Moment, Duration } from 'moment'
import { JobSearchResponse } from '@/models/types/job-search-response'
import { ACTIVE, PAUSED, COMPLETED, CANCELLED, ApprovalStatus } from '@/models/job'

export interface FilteredSearchJob extends JobSearchResponse {
  estimatedDuration: Duration
  estimatedCompletedTime: Moment
  isOverdue: boolean
  isLate: boolean
  startTime: string
  endTime: string
  approvalStatus: ApprovalStatus
}

export class FilteredSearchJob {
  constructor(job: JobSearchResponse) {
    Object.assign(this, job)

    const start = moment(job.requested_start)
    const end = moment(job.requested_end)
    this.estimatedDuration = moment.duration(end.diff(start))
    this.estimatedCompletedTime = moment(job.active_time ?? job.requested_start).add(
      this.estimatedDuration,
    )
    this.isOverdue = job.status !== COMPLETED && job.status !== CANCELLED && start.isBefore()
    this.isLate =
      (job.status === ACTIVE || job.status === PAUSED) && this.estimatedCompletedTime.isBefore()
    this.startTime = job.requested_start
    this.endTime = job.requested_end
    this.approvalStatus = job.approval_status ?? ApprovalStatus.NO_APPROVAL
  }
}
